import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface FormFieldMessageProps {
  children: ReactNode;
  className?: string;
  variant?: 'user' | 'assistant';
}

export const FormFieldMessage = ({ 
  children, 
  className,
  variant = 'assistant' 
}: FormFieldMessageProps) => {
  return (
    <div 
      className={cn(
        "rounded-lg p-4 mb-2 transition-all",
        variant === 'assistant' 
          ? "bg-muted/50 border border-border/50" 
          : "bg-primary/5 border border-primary/20 ml-12",
        className
      )}
    >
      {children}
    </div>
  );
};
